/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommunicationsLetterPublicationsAddPublicationDateModel } from './communications-letter-publications-add-publication-date-model';

export interface CommunicationsLetterPublicationsPublishLetterListModel {
  letterIds: Array<string>;
  seasonId: string;
  seasonType?: CommunicationsLetterPublicationsPublishLetterListModelSeasonTypeEnum | null;
  workflowId?: string;
  managerType?: CommunicationsLetterPublicationsPublishLetterListModelManagerTypeEnum | null;
  employeeTaskTemplateId?: string | null;
  employeeMailTemplateId?: string | null;
  managerTaskTemplateId?: string | null;
  managerMailTemplateId?: string | null;
  hrBusinessPartnerMailTemplateId?: string | null;
  autoApprove?: boolean | null;
  overriddenPublicationDates?: Array<CommunicationsLetterPublicationsAddPublicationDateModel> | null;
}
export enum CommunicationsLetterPublicationsPublishLetterListModelSeasonTypeEnum {
  Unknown = 'Unknown',
  Sog = 'SOG',
  Gbr = 'GBR',
  Merit = 'Merit',
  IncentiveV2 = 'IncentiveV2',
  SpecialPaymentCash = 'SpecialPaymentCash',
  SpecialPaymentEquity = 'SpecialPaymentEquity',
  PositionEvaluation = 'PositionEvaluation',
  Restructuring = 'Restructuring'
}
export enum CommunicationsLetterPublicationsPublishLetterListModelManagerTypeEnum {
  LineManager = 'LineManager',
  CompanyManager = 'CompanyManager',
  None = 'None'
}
